import * as React from 'react';

import { Alert } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider/LocalizationProvider';
import moment, { Moment } from 'moment';

import useTimezone from '../../../hooks/shared/useTimeZone';
import { momentDate } from '../../../utils/date';

interface IDatePicker {
  value: Date | null;
  setAnswer: (v: Date | null) => void;
}

const DatePicker = ({ value, setAnswer }: IDatePicker) => {
  const timezone = useTimezone();

  const [cleared, setCleared] = React.useState<boolean>(false);

  const parsedValue = Array.isArray(value)
    ? null
    : value
      ? momentDate(value).tz(timezone)
      : null;

  const handleChange = (value: Moment | null) => {
    if (value && value.isValid()) {
      const today = moment().tz(timezone).startOf('day');

      if (value.isSame(today, 'day')) {
        value = value.tz(timezone).startOf('day');
        const date = value.toDate();

        return setAnswer(date);
      }

      value = value.tz(timezone).startOf('day');
      const date = value.toDate();

      return setAnswer(date);
    } else {
      return setAnswer(null);
    }
  };

  React.useEffect(() => {
    if (cleared) {
      const timeout = setTimeout(() => {
        setCleared(false);
      }, 1500);

      return () => clearTimeout(timeout);
    }
    return () => {};
  }, [cleared]);

  return (
    <LocalizationProvider
      data-testid="date-picker-option-component"
      dateAdapter={AdapterMoment}
    >
      <DesktopDatePicker
        className="w-100"
        format="DD/MM/YYYY"
        slotProps={{
          field: { clearable: true, onClear: () => setCleared(true) },
        }}
        value={parsedValue}
        onChange={handleChange}
        timezone={timezone}
      />

      {cleared && (
        <Alert
          sx={{ position: 'absolute', bottom: 0, right: 0 }}
          severity="success"
        >
          Field cleared!
        </Alert>
      )}
    </LocalizationProvider>
  );
};

export default DatePicker;
